import React from 'react';

import { DefaultServerTitleWrapper } from '~src/authentication/components/loginSpace/DefaultServerTitleWrapper';

import { SlackIntegrationErrorPage } from './SlackIntegrationErrorPage';

export const SlackIntegrationErrorProvider = (): JSX.Element => {
    return (
      <DefaultServerTitleWrapper>
        <div>
          <SlackIntegrationErrorPage />
        </div>
      </DefaultServerTitleWrapper>
    );
};
